import {ParsedUrlQuery} from 'querystring';
import {convertQueryInputToSingleElement} from '../../common/shared/utils/convertQueryInputToSingleElement';

export function getFreeSeriesParamFromQuery({
  uidInfoList,
  query,
}: {
  uidInfoList: string[];
  query?: ParsedUrlQuery;
}) {
  const [category_uid] = uidInfoList;
  const categoryUid = convertQueryInputToSingleElement(category_uid);
  const tabUid = convertQueryInputToSingleElement(query?.tab_uid);
  return {
    categoryUid: Number(categoryUid),
    tabUid,
  };
}
